import AppConfig from './AppConfig';
import Cookies from 'universal-cookie';
import md5 from "js-md5";
export const baseUrl = AppConfig.serverUrl();
class ApiManager {
    constructor() {
        if (!ApiManager.instance) {
            this.apiData = {}; // 用于保存所有的 API 返回数据
            ApiManager.instance = this;
        }
        this.cookies = new Cookies(null, { path: '/' }); // 初始化 cookies
        this.token = "";
        localStorage.setItem("record", "[]");
        return ApiManager.instance;
    }

    setToken = (token) => {
        this.token = token;
    }
    saveData = (method, key, data) => {
        this.apiData[key] = data;
    }
    getHeader = (token, isForm) => {
        if (AppConfig.sso) {
            if (isForm) {
                return new Headers({
                });
            }
            else {
                return new Headers({
                    'Content-Type': 'application/json',
                });
            }
        }
        else {
            if (isForm) {
                return new Headers({
                    'Authorization': 'Bearer ' + token
                })
            }
            else {
                return new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                })
            }
        }
    }

    fetchRequest = (url, method, body = null, query = {},isForm=false) => {
        let fullUrl = url;
        if (method === 'GET' && Object.keys(query).length > 0) {
            let queryString = new URLSearchParams(query).toString();
            queryString = queryString.replace(/%2C/g, ',');
            fullUrl = `${url}?${queryString}`;
        }
        console.log(`${method}:`, fullUrl, this.token);
        const options = {
            method,
            credentials: AppConfig.sso ? 'include' : 'omit',
            headers: this.getHeader(this.token,isForm),
        };
        if (body) {
            options.body = body;
        }
        return fetch(baseUrl + fullUrl, options).then(async (response) => {
            if (response.status === 200) {
                return await response.json();
            } else if (response.status === 204) {
                return [];
            } else {
                const errorText = await response.text();
                console.error(`Error ${response.status}:`, errorText);
                throw new Error(typeof errorText === "object" ? errorText.message || JSON.stringify(errorText) : errorText);
            }
        }).catch((error) => {
            console.error('Fetch Error:', error);
            throw error;
        });
    };

    // GET 方法
    fetchGet = (url, query, cacheMins = 0) => {
        return this.fetchRequest(url,"GET",null,query);
    };

    // POST 方法
    fetchPost = (url, body, cacheMins = 0) => {
        return this.fetchRequest(url,"POST",JSON.stringify(body));
    };

    // PUT 方法
    fetchPut = (url, body, cacheMins = 0) => {
        return this.fetchRequest(url,"PUT",JSON.stringify(body));
    };

    fetchPostForm = (url, formData) =>  {
        return this.fetchRequest(url,"POST",formData,null,true);
    };
    fetchPutForm = (url, formData) =>  {
        return this.fetchRequest(url,"PUT",formData,null,true);
    };
    // DELETE 方法
    fetchDelete = (url, body = null, cacheMins = 0)=> {
        return this.fetchRequest(url,"DELETE",JSON.stringify(body));
    };

    // 获取调用过的 API 数据
    getApiData = (url) => {
        return this.apiData[url] || null;
    };

}

const instance = new ApiManager();

export default instance;
